module.exports = __webpack_public_path__ + "media/images/operation_jobs/door_close_sharp_dryer-baf11c9478319de3932b5cc9f469ebc6.gif";